import React from "react";
import { useEffect } from "react";
import Navbar from "../components/site/Navbar";
import NoticeBar from "../components/site/NoticeBar";
import Hero from "../components/site/Hero";
import GapSection from "../components/site/GapSection";
import WhatsInside from "../components/site/WhatsInside";
import ProgramSchedule from "../components/site/ProgramSchedule";
import ShowNight from "../components/site/ShowNight";
import StatsBar from "../components/site/StatsBar";
import IsThisYou from "../components/site/IsThisYou";
import Investment from "../components/site/Investment";
import FAQ from "../components/site/FAQ";
import Marquee from "../components/site/Marquee";
import ApplyForm from "../components/site/ApplyForm";
import Footer from "../components/site/Footer";
import { initTracking } from "../lib/analytics";

export default function LandingPage() {
  useEffect(() => {
    initTracking();
  }, []);

  return (
    <main className="relative">
      <NoticeBar />
      <Navbar />
      <Hero />
      <GapSection />
      <WhatsInside />
      <ProgramSchedule />
      <ShowNight />
      <StatsBar />
      <IsThisYou />
      <Marquee />
      <Investment />
      <FAQ />
      <ApplyForm />
      <Footer />
    </main>
  );
}
